import { ThemeComponent } from "@/theme/ThemeComponent";
import { OptionSelector } from "@/utils/OptionSelectors";
import { Component, Prop, Ref, SimpleEvent } from "@eastsideco/salvo-ts";
import { ProductOption } from "./ProductOptionPicker";

interface ValueRadio extends HTMLInputElement {
    dataset: {
        value: string;
    };
}

@Component
export class ProductButtonOption extends ThemeComponent implements ProductOption {
    @Prop name!: string;
    @Prop values!: string[];
    @Prop selected!: string | null;
    @Prop position!: number;

    @Ref({ required: false }) buttons!: ValueRadio[];
    @Ref({required: false}) labelSelectedOption?: HTMLElement;

    private valuesWithoutStock: string[] = [];
    private valuesWithoutVariant: string[] = [];

    private _onChange = new SimpleEvent<string | null>();
    public get onChange() {
        return this._onChange.asEvent();
    }

    init() {
        if (!this.buttons) { return; }
        for (const button of this.buttons) {
            this.$log.error('hu', [button, typeof button]);
            this.$listen(button, 'change', () => {
                if (!button.checked) { return; }

                const value = button.value || null;
                this.select(value);

                // Update label selected value
                if (this.labelSelectedOption && value) {
                    this.labelSelectedOption.textContent = value.toLowerCase();
                }

                this._onChange.dispatch(value);
            });

        }
        this._onChange.dispatch(this.selected);
        this.updateButtonStyles();


    }

    public select(value: string | null) {
        this.selected = value;
        this.updateButtonStyles();
    }

    public updateBasedOnSelector(selector: OptionSelector) {
        this.valuesWithoutStock = selector.options[this.position - 1].values
            .filter((v) => v.outOfStock).map((v) => v.value);
        this.valuesWithoutVariant = selector.options[this.position - 1].values
            .filter((v) => !v.variantExists).map((v) => v.value);

        this.updateButtonStyles();
    }

    private updateButtonStyles() {
        for (const button of this.buttons) {
            const value = button.value;
            const selected = (value || null) == this.selected;
            const outOfStock = this.valuesWithoutStock.indexOf(value) > -1;
            const noVariant = this.valuesWithoutVariant.indexOf(value) > -1;

            const next = button.nextSibling;

            if (button.parentNode == null) { return; }

            const $wrapper = button.parentNode as HTMLElement;
            selected ? $wrapper.classList.add('is-active') : $wrapper.classList.remove('is-active');
            $wrapper.style.opacity = noVariant ? '0.3' : (outOfStock ? '0.6' : '1');
        }
    }
}

